import { get, post } from "./http"


export const getWebconfig = params => get("/getwebconfig", params);
export const getindex = params => get("/getindex", params);
// 所有下级类别
export const getchild = params => post("/getchild", params);
export const getabout = params => post("/getabout", params);

export const getnews = params => post("/getnews", params);
export const getarticle = params => post("/getarticle", params);
export const getproduct = params => post("/getproduct", params);
export const getsearch = params => post("/getsearch", params);
export const getproview = params => post("/getproview", params);

// 服务热线
export const getalone = params => post("/getalone", params);
export const addmsg = params => post("/addmsg", params);
// 招聘
export const joblist = params => post("/joblist", params);
export const jobview = params => post("/jobview", params);



